exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".optionsToggle {\n  cursor: pointer;\n  font-size: 18px; }\n\n.IsOff i {\n  color: black; }\n\n.IsOff span {\n  color: gray; }\n\n.IsOn i {\n  color: gold; }\n\n.IsOn span {\n  color: black; }\n\n.set-audience {\n  margin-top: 5px;\n  margin-left: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/publishProcessModal/setAudience/set-audience.component.scss
// module id = ../../../../../src/app/shared/publishProcessModal/setAudience/set-audience.component.scss
// module chunks = main